"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRouterPrompt = void 0;
var react_1 = require("react");
var RouterBlocker_1 = require("./RouterBlocker");
function useRouterPrompt(navigate, location, when) {
    var _a = (0, react_1.useState)(false), showPrompt = _a[0], setShowPrompt = _a[1];
    var _b = (0, react_1.useState)(null), lastLocation = _b[0], setLastLocation = _b[1];
    var _c = (0, react_1.useState)(false), confirmedNavigation = _c[0], setConfirmedNavigation = _c[1];
    var cancelNavigation = (0, react_1.useCallback)(function () {
        setShowPrompt(false);
    }, []);
    var handleBlockedNavigation = (0, react_1.useCallback)(function (nextLocation) {
        if (!confirmedNavigation &&
            nextLocation.location.pathname !== location.pathname) {
            setShowPrompt(true);
            setLastLocation(nextLocation);
            return false;
        }
        return true;
    }, [confirmedNavigation]);
    var confirmNavigation = (0, react_1.useCallback)(function () {
        setShowPrompt(false);
        setConfirmedNavigation(true);
    }, []);
    (0, react_1.useEffect)(function () {
        if (confirmedNavigation && lastLocation) {
            navigate(lastLocation.location.pathname);
        }
    }, [confirmedNavigation, lastLocation]);
    (0, RouterBlocker_1.useRouterBlocker)(handleBlockedNavigation, when);
    return [showPrompt, confirmNavigation, cancelNavigation];
}
exports.useRouterPrompt = useRouterPrompt;
//# sourceMappingURL=RouterPrompt.js.map